<template>
  <b-modal ref="AddingPurchaseCostToPackageModal" :title="`Package № ${priceData.package_nr}`"
           :no-close-on-backdrop="true">
    <div>
      <b-row>
        <b-col>
          <label>{{$t('labels.purchase_orders.purchase_order_item')}}</label>
          <multiselect v-model="priceData.purchase_order_item" :max-height="200" placeholder=""
                       label="description" track-by="id" :options="purchaseOrderItems"
                       @select="applyOrderItemData" @remove="unSelectPurchaseOrder"
                       select-label="" deselect-label="" selected-label=""></multiselect>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>{{$t('labels.common.thickness')}}</label>
          <input class="form-control" v-model="priceData.thickness" disabled>
        </b-col>
        <b-col>
          <label>{{$t('labels.common.width')}}</label>
          <input class="form-control" v-model="priceData.width" disabled>
        </b-col>
        <b-col>
          <label>{{$t('labels.common.length')}}</label>
          <input class="form-control" v-model="priceData.length" disabled>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="8">
          <label>
            {{$t('labels.common.actual_price')}}{{unitPriceLabel}}
          </label>
          <input class="form-control" v-model="priceData.price_per_unit" disabled>
        </b-col>
        <b-col class="d-flex align-self-bottom">
          <input class="form-control" v-model="priceData.measure_type" disabled>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="8">
          <label>
            {{$t('labels.common.defect_value')}}, {{priceData.penalty_measure}}
          </label>
          <input class="form-control" v-model="priceData.penalty_perc" :disabled="!priceData.purchase_order_item">
        </b-col>
        <b-col class="d-flex align-self-bottom">
          <multiselect v-model="priceData.penalty_measure" :max-height="200" placeholder=""
                       :disabled="!priceData.purchase_order_item"
                       :options="measures" select-label="" deselect-label="" selected-label=""></multiselect>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>
            {{$t('labels.common.additional_price')}}{{unitPriceLabel}}
          </label>
          <input class="form-control" v-model="priceData.penalty" :disabled="!priceData.purchase_order_item">
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>{{$t('labels.common.comment')}}</label>
          <input type="text" class="form-control" v-model="priceData.comment">
        </b-col>
      </b-row>
    </div>
    <div slot="modal-footer" class="w-100 text-center">
      <b-btn size="sm" variant="success" @click="save">
        {{$t('buttons.common.save')}}
      </b-btn>
    </div>
  </b-modal>
</template>

<script>
  import { handlerResponse } from '@/helpers/commonHelpers';
  import { notificationsRenderer } from '@/helpers/renderHelpers';
  import Multiselect from 'vue-multiselect';

  export default {
    props: ['fetchCallback'],
    components: {Multiselect},
    data() {
      return {
        purchaseOrderItems: [],
        measures: ['%'],
        initialPriceData: {
          purchase_order_item: null,
          thickness: '',
          width: '',
          length: '',
          price_per_unit: '',
          measure_type: '',
          penalty_perc: '',
          penalty_measure: null,
          penalty: '',
          comment: ''
        },
        priceData: {},
        relatedPackageData: {}
      }
    },
    methods: {
      async fetchOptionsData() {
        const params = {
          related_fields: 'purchase_order_item'
        }
        const packageId = this.priceData.id;
        try {
          const response = await this.$http.get(`woodware/movement_data/${packageId}/purchase_prices/`, {params})
            .then(handlerResponse);
          const {purchase_order_item} = response;
          this.purchaseOrderItems = purchase_order_item;
        } catch (e) {
          console.log(e);
        }
      },
      transformData(data) {
        this.priceData.thickness = data.thickness_nominal || this.priceData.thickness;
        this.priceData.width = data.width_nominal || this.priceData.width;
        this.priceData.length = data.length_nominal || this.priceData.length;
        delete data.id;
        this.priceData = {...this.priceData, ...data};
      },
      applyOrderItemData(order) {
        if (order.measure_type !== '%') {
          this.measures = [...this.measures, order.measure_type];
        }
        this.transformData(order);
      },
      unSelectPurchaseOrder() {
        this.measures = ['%'];
        this.priceData = {...this.relatedPackageData};
        this.setDefaultData();
      },
      prepareSavedData() {
        return {
          purchase_order_item: this.priceData.purchase_order_item && this.priceData.purchase_order_item.id,
          penalty_value_nominal: this.priceData.penalty_perc,
          penalty_measure: this.priceData.penalty_measure,
          penalty: this.priceData.penalty,
          comment: this.priceData.comment
        }
      },
      save() {
        const payload = this.prepareSavedData();
        this.$http.put(`woodware/movement_data/${this.priceData.id}/purchase_prices/`, payload)
          .then(handlerResponse).then(() => {
          this.fetchCallback();
          this.$refs['AddingPurchaseCostToPackageModal'].hide();
        }).catch(error => notificationsRenderer(error.data, 'error'))
      },
      setDefaultData() {
        this.priceData.penalty_measure = '%';
      }
    },
    mounted() {
      this.$root.$on('openAddingPurchaseCostToPackageModal', async (data) => {
        this.priceData = {...this.initialPriceData};
        this.relatedPackageData = {...data};
        this.measures = ['%'];
        this.setDefaultData();
        this.priceData = {...this.priceData, ...this.relatedPackageData};
        const {purchase_order_item} = data;
        data.purchase_order_item && this.applyOrderItemData({...purchase_order_item});
        if (this.$refs['AddingPurchaseCostToPackageModal']) {
          await this.fetchOptionsData();
          this.$refs['AddingPurchaseCostToPackageModal'].show();
        }
      });
    },
    computed: {
      unitPriceLabel() {
        return this.priceData.measure_type && `, ${this.priceData.currency_code}/${this.priceData.measure_type}`;
      }
    },
    beforeDestroy() {
      this.$root.$off('openAddingPurchaseCostToPackageModal');
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/modals/AddingPurchaseCostToPacket.vue